// @ core
const apiURLBuilder = require("core/apiURLBuilder");

// @ utilities
const { APIGet } = require("utilities/APIRequestHelper");
const { getLanguage } = require('core/i18n').i18n;
const sanitizeHelper = require('utilities/sanitizeHelper');

// @ constants
const actionTypes = require("constants/actionTypes");

const requestIndexesDataFetching = () => ({
    type: actionTypes.BROKER_INDEXES_DATA_FETCHING
});

const requestFinancesNewsFetching = () => ({
    type: actionTypes.BROKER_FINANCES_NEWS_FETCHING
});

const requestLastNewsFetching = () => ({
    type: actionTypes.BROKER_LAST_NEWS_FETCHING
});

const requestIndexesDataSuccess = indexes => ({
    type: actionTypes.BROKER_INDEXES_DATA_SUCCESS,
    payload: {
        data: indexes
    }
});

const requestFinancesNewsSuccess = financesNews => ({
    type: actionTypes.BROKER_FINANCES_NEWS_SUCCESS,
    payload: {
        data: financesNews
    }
});

const requestLastsNewsSuccess = data => ({
    type: actionTypes.BROKER_LAST_NEWS_SUCCESS,
    payload: {
        news: data.news,
        allTabs: [ data.lastNewsTab, ...data.restOfTabs],
        newsPerPage: data.newsPerPage,
        totalNews: data.totalNews
    }
});

const requestLastNewsBodySuccess = (news, urn) => ({
    type: actionTypes.BROKER_LAST_NEWS_BODY_SUCCESS,
    urn: urn,
    news: news
})

const requestLastsNewsSuccessTab = (news, tabName) => ({
    type: actionTypes.BROKER_LAST_NEWS_TAB_SUCCESS,
    news : news,
    tabName: tabName
});

const requestIndexesDataError = () => ({
    type: actionTypes.BROKER_INDEXES_DATA_ERROR
});

const requestFinancesNewsError = () => ({
    type: actionTypes.BROKER_FINANCES_NEWS_ERROR
});

const requestLastsNewsError = () => ({
    type: actionTypes.BROKER_LAST_NEWS_ERROR
});

const requestIndexesData = (
    isinList,
    fromDate = "",
    toDate = "",
    operation = "INTERDAY"
) => dispatch => {
    dispatch(requestIndexesDataFetching());

    const getIndexes = isinList.map(isin => {
        return APIGet({
            dispatch,
            endpoint: "timeSeries",
            url: apiURLBuilder.getURL("timeSeries", {
                isin,
                operation,
                fromDate: encodeURIComponent(fromDate),
                toDate: encodeURIComponent(toDate)
            })
        }).catch(() => {
            dispatch(requestIndexesDataError());
        });
    });

    return Promise.all(getIndexes)
        .then(responses => {
            dispatch(requestIndexesDataSuccess(responses));
        })
        .catch(() => {
            dispatch(requestIndexesDataError());
        });
};

const requestIndexesDataMedysif = (isinList, fromDate = '') => (dispatch, getState) => {
    dispatch(requestIndexesDataFetching());
    const getIndexes = isinList.map((indexData) => {
        const exchangeId = indexData.get('exchangeId');
        const spcSymbol = indexData.get('spcSymbol');
        const originCountry = getState().profile.get('originCountry');

        return APIGet({
            dispatch,
            endpoint: 'intradayDataMedysif',
            url: apiURLBuilder.getURL('intradayDataMedysif',
                {
                    exchangeId: exchangeId,
                    spcSymbol: spcSymbol,
                    fromDate: encodeURIComponent(fromDate),
                    originCountry: originCountry
                }
            ),
        })
        .catch(() => {
            dispatch(requestIndexesDataError())
        });
    })

    return Promise.all(getIndexes)
        .then((responses) => {
            dispatch(requestIndexesDataSuccess(responses))
        })
        .catch(() => {
            dispatch(requestIndexesDataError())
    });
}

const requestIndexesHistoricalDataMedysif = (isinList, fromDate = '', toDate = '') => (dispatch, getState) => {
    dispatch(requestIndexesDataFetching());
    const getIndexes = isinList.map((indexData) => {
        const exchangeId = indexData.get('exchangeId');
        const spcSymbol = indexData.get('spcSymbol');
        const originCountry = getState().profile.get('originCountry');

       return APIGet({
            dispatch,
            endpoint: 'historicalDataMedysif',
            url: apiURLBuilder.getURL('historicalDataMedysif',
                {
                    exchangeId: exchangeId,
                    spcSymbol: spcSymbol,
                    fromDate: encodeURIComponent(fromDate),
                    toDate: encodeURIComponent(toDate),
                    originCountry: originCountry
                }
            ),
        })
        .catch(() => {
            dispatch(requestIndexesDataError())
        });
    })

    return Promise.all(getIndexes)
        .then((responses) => {
            dispatch(requestIndexesDataSuccess(responses))
        })
        .catch(() => {
            dispatch(requestIndexesDataError())
    });
}



const requestFinancesNews = () => dispatch => {
    dispatch(requestFinancesNewsFetching());

    return APIGet({
        dispatch,
        endpoint: "marketFinancesNews",
        url: apiURLBuilder.getURL("marketFinancesNews")
    })
        .then(response =>
            dispatch(
                requestFinancesNewsSuccess(
                    response.onlineReports.filter(
                        report => report.title1 !== null
                    )
                )
            )
        )
        .catch(response => dispatch(requestFinancesNewsError(response.error)));
};

const requestLastNews = () => dispatch => {
    dispatch(requestLastNewsFetching());
    const language = getLanguage();
    return APIGet({
        dispatch,
        endpoint: "marketLastNews",
        url: apiURLBuilder.getURL("marketLastNews", { language })
    })
        .then(response => {
            const cleanNews = response.news
                .filter(report => report.title !== null)
                .map (report => {
                    report.title = sanitizeHelper.sanitizeData(report.title);
                    return report;
                });
            response.news = cleanNews;
            dispatch(requestLastsNewsSuccess(response));
        })
        .catch(response => dispatch(requestLastsNewsError(response.error)));
};

const requestAllNews = () => dispatch => {
    dispatch(requestLastNews());
    dispatch(requestFinancesNews());
};

const requestTabLastNews = tabNumber => dispatch => {
    dispatch(requestLastNewsFetching())
    const language = getLanguage();
    APIGet({
        dispatch,
        endpoint: "marketLastNewsTab",
        url: apiURLBuilder.getURL("marketLastNewsTab", { tabNumber, language })
    })
        .then(response => {
            const cleanNews = response.news
                .filter(report => report.title !== null)
                .map (report => {
                    report.title = sanitizeHelper.sanitizeData(report.title);
                    return report;
                });
            response.news = cleanNews;
            dispatch(requestLastsNewsSuccessTab(response.news, tabNumber))
        })
        .catch(response => dispatch(requestLastsNewsError(response.error)));
}

const requestBodyLastNews = urn => dispatch => {
    dispatch(requestLastNewsFetching());
    APIGet({
        dispatch,
        endpoint: "marketLastNewsBody",
        url: apiURLBuilder.getURL("marketLastNewsBody", {urn})
    })
        .then(response => {
            response.title = sanitizeHelper.sanitizeData(response.title)
            dispatch(requestLastNewsBodySuccess(response, urn))
        })
        .catch(response => dispatch(requestLastsNewsError(response.error)));
}

module.exports = {
    requestIndexesData,
    requestIndexesDataMedysif,
    requestIndexesHistoricalDataMedysif,
    requestLastNews,
    requestFinancesNews,
    requestAllNews,
    requestTabLastNews,
    requestBodyLastNews
};
